import { Direccion } from './direccion';

export class User {
    uid=""
    datos={
        name:"",
        apellido: "",
        email:"",
        imagen:"",
        role:"user",
        doctas:0,
        wallet_pass:"",
        celular:"",
        address:""
    }
    direccion= Object.assign({},new Direccion);
    reciclables=[]//reciclables totales entregados en el servicio de retiros + los llevados a puestos de reciclaje {id, cantidad}
    token=""
    solicitado: false;
}
